import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';
import ReactJSSvg from 'devicon/icons/react/react-original.svg';

export const ReactJS = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="lang-react" className={cx('sdkIcon', className)} size={size} {...props}>
    <ReactJSSvg />
  </LegacyIcon>
);
